/* Shared search and footer controls on every template. Native newsletter submission stays server-handled. */
(() => {
  const init = () => {
    const panel = document.querySelector('.search-panel');
    const toggle = document.querySelector('#search-toggle');
    if (panel && toggle) {
      const setOpen = (open, restoreFocus = false) => {
        if (open) {
          const mobile = document.querySelector('.mobile-toggle');
          if (mobile?.getAttribute('aria-expanded') === 'true') mobile.click();
        }
        panel.hidden = !open;
        toggle.setAttribute('aria-expanded', String(open));
        if (open) panel.querySelector('input[type="search"]')?.focus();
        else if (restoreFocus) toggle.focus();
      };
      toggle.setAttribute('aria-controls', panel.id);
      toggle.setAttribute('aria-expanded', 'false');
      toggle.addEventListener('click', () => setOpen(panel.hidden));
      panel.querySelector('.dd-search-close')?.addEventListener('click', () => setOpen(false, true));
      document.addEventListener('keydown', e => { if (e.key === 'Escape' && !panel.hidden) { e.preventDefault(); setOpen(false, true); } });
      document.addEventListener('click', e => { if (!panel.hidden && !panel.contains(e.target) && !toggle.contains(e.target)) setOpen(false); });
    }
    // Homepage/PDP own their animation timers; other templates need the same footer controls.
    document.querySelector('#contrast-toggle')?.addEventListener('click', e => {
      if (e.currentTarget.onclick) return;
      const on = document.body.classList.toggle('high-contrast');
      e.currentTarget.setAttribute('aria-pressed', String(on));
    });
    document.querySelector('#motion-toggle')?.addEventListener('click', e => {
      if (e.currentTarget.onclick) return;
      const off = document.body.classList.toggle('no-motion');
      e.currentTarget.setAttribute('aria-pressed', String(off));
      e.currentTarget.textContent = off ? 'enable animation' : 'disable animation';
    });
    const help = document.querySelector('.help-launcher'), dialog = document.querySelector('#preview-dialog');
    if (help && dialog) {
      help.addEventListener('click', () => {
        if (help.onclick) return;
        dialog.querySelector('.dialog-content').innerHTML = '<h2>How can we help?</h2><p><a href="/pages/contact-us">Contact Divine Derriere</a></p><p><a href="/policies/shipping-policy">Shipping information</a></p><p><a href="/policies/refund-policy">Returns</a></p>';
        dialog.showModal();
      });
      dialog.querySelector('.dialog-close')?.addEventListener('click', () => { if (!help.onclick) dialog.close(); });
    }
    const message = document.querySelector('#signup-message');
    if (message && new URLSearchParams(location.search).has('customer_posted')) message.focus();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
})();
